import {
  getPrice,
} from "apps/website/components/feature/PayPalExpressCheckout/v1/get-price";
import {
  PayPalExpressCheckout,
} from "apps/website/components/feature/PayPalExpressCheckout/PayPalExpressCheckout";
import Column from "apps/website/components/layout/Column/Column";

export const FormPayPalExpressCheckout = ({
  flowId,
  onSuccess,
}: {
  flowId: string;
  onSuccess: () => void;
}) => {
  const price = getPrice(flowId);

  return (
    <Column className="gap-4">
      <PayPalExpressCheckout
        version="v1"
        price={ price }
        onSuccess={ onSuccess }
      />
    </Column>
  );
};
